import React, {ReactNode} from "react"
import {ContentBannerWrapper} from "./components"

type StandardContentWrapperProps = {
    children: ReactNode
    quickLinkCount: number
    enableContentBanner: boolean
}

export const StandardContentWrapper = (props: StandardContentWrapperProps) => {
    const {children, quickLinkCount, enableContentBanner} = props

    return (
        <ContentBannerWrapper quickLinkCount={quickLinkCount} enableContentBanner={enableContentBanner}>
            {children}
        </ContentBannerWrapper>
    )
}

export default StandardContentWrapper
